import { render } from "./SectionsDashboard.vue?vue&type=template&id=da149296"
import script from "./SectionsDashboard.vue?vue&type=script&lang=js"
export * from "./SectionsDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__